import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67ee02b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Masz pytanie?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Zadaj je na grupie Izolacje ROCKWOOL! ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMenu())),
          class: _normalizeClass(["mobile-menu--trigger", { open: _ctx.open }])
        }, _hoisted_5, 2),
        _createElementVNode("nav", {
          class: _normalizeClass(["mobile-menu", { open: _ctx.open }])
        }, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `mobile-menu-item-${index}`
              }, [
                (!item.external)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open = false)),
                      to: { name: item.url }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.open = false)),
                      href: item.url,
                      target: "_blank"
                    }, _toDisplayString(item.name), 9, _hoisted_6))
              ]))
            }), 128))
          ]),
          _createElementVNode("a", {
            href: _ctx.fbUrl,
            target: "_blank",
            class: "mobile-menu--fb"
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "fa-brands fa-facebook" }),
            _hoisted_8
          ], 8, _hoisted_7)
        ], 2)
      ]))
    : _createCommentVNode("", true)
}